export enum ContentType {
  Homepage = 'acko-homepages',
  Productpage = 'product-pages',
  Product = 'products',
  Blogs = 'blogs',
  News = 'newss',
  Review = 'reviewss',
  AckodriveBlogs = 'blog-ads',
  Brand = 'brands',
  Article = 'articles',
  SocialMediaUserFeedbacks = 'social-media-user-feedbacks',
  Careerpage = 'career-pages',
  AckoAuthor = 'authors',
  AckodriveAuthor = 'author-ads',
  Fuelpage = 'fuel-pages',
  AckodriveTopics = 'topic-ads',
  GlobalHeader = 'global-headers',
  BusinessPage = 'business-pages',
  EnterpriseHome = 'enterprise-homes',
  BusinessCategoryPage = 'business-category-pages',
  CustomerStory = 'customer-stories',
  ContactUs = 'contact-uses',
  GlobalHeaderQuark = 'global-header-quarks',
  GlobalFooter = 'global-footers',
  NewHomePage = 'home-pages',
  EnterprisePriceCalculator = 'enterprise-price-calculators',
}
